<template>
	<div class="manage_app p_background clearfix">
		<h3 class="all_title" id="top_title">{{title}}</h3>
		<div class="table_box user-select clearfix container_box">
			<div class="basic_container">
					<div class="container-fluid">
						
			<!--学校名称-->
			<section class="form_box">
				<label class="form_label" for=""><i class="must_color">*</i>学校名称：</label>
				<input type="text" id="school_name" v-model="tCloudServiceSchool.schoolName" class="form-control form_control" maxlength="30" name="yymc" />
				<span class="tip_sub_text text_margin_left"></span>
			</section>
			<!--学校IP-->
			<section class="form_box">
				<label class="form_label" for=""><i class="must_color">*</i>学校URL：</label>
				<input type="text" id="school_ip" v-model="tCloudServiceSchool.schoolUrl" class="form-control form_control" maxlength="40" name="yymc" />
				<span class="tip_sub_text text_margin_left"></span>
			</section>
			<!--学校域名
			<section class="form_box">
				<label class="form_label" for=""><i class="must_color">*</i>学校域名：</label>
				<input type="text" id="issue_applyName" v-model="tCloudServiceSchool.schoolDomainname" class="form-control form_control" maxlength="40" name="yymc" />
				<span class="tip_sub_text text_margin_left"></span>
			</section>-->
			<!--联系地址-->
			<section class="form_box">
				<label class="form_label" for=""><i class="must_color">*</i>学校地址：</label>
				<select class="form-control form_control form_select" name="" id="register_addressprovince" v-model="tCloudServiceSchool.addressProvince" @change="queryProvinceCity('0','0',$event)">
					<option value="">请选择</option>
					<option v-for="option in provinceOptions" v-bind:value="option.id">
						{{ option.dictionaryname }}
					</option>
				</select>
				<select class="form-control form_control form_select" name="" id="register_addresscity" v-model="tCloudServiceSchool.addressCity" @change="queryProvinceCity('0','1',$event)">
					<option value="">请选择</option>
					<option v-for="cityoption in cityOptions" v-bind:value="cityoption.id">
						{{ cityoption.dictionaryname }}
					</option>
				</select>
				<select class="form-control form_control form_select" name="" id="register_addressstreet" v-model="tCloudServiceSchool.addressCounty" @change="queryProvinceCity('0','2',$event)">
					<option value="">请选择</option>
					<option v-for="streetoption in streetOptions" v-bind:value="streetoption.id">
						{{ streetoption.dictionaryname }}
					</option>
				</select>
				
				<!--<input type="text" class="form-control form_control" id="register_addressdetail" placeholder="请请输入详细地址" v-model="tCloudServiceSchool.addressDetails" />
				<p class="prompt_msg">
					<small class="tip_sub_text">
    					（请填写详细联系地址）
    				</small>
				</p>-->
			</section>
			<!--安卓下载地址-->
			<section class="form_box">
				<label class="form_label" for=""><i class="must_color">*</i>android应用下载地址：</label>
				<input type="text" id="android_url" v-model="tCloudServiceSchool.androidDownload" style="width: 400px" class="form-control form_control" maxlength="400" name="yymc" />
				<span class="tip_sub_text text_margin_left"></span>
			</section>
			<!--IOS下载地址-->
			<section class="form_box">
				<label class="form_label" for=""><i class="must_color">*</i>IOS应用下载地址：</label>
				<input type="text" id="ios_url" v-model="tCloudServiceSchool.iosDownload" style="width: 428px" class="form-control form_control" maxlength="400" name="yymc" />
				<span class="tip_sub_text text_margin_left"></span>
			</section>
			<div class="btn_box text-center partition_message">
				<span id="save_app_btn" class="btn btn_submit" @click="doSubmit($event)">确认{{title}}</span>
				<span id="inspect_app_btn" class="btn btn_submit" @click="doSubmit($event)">取消</span>
			</div>
		</div></div></div>
	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'

	export default {
		name: 'schoolinfo_edit',
		data() {
			return {
				eid:'',
				title:'',
				provinceOptions: '',
				cityOptions: '',
				streetOptions: '',
				tCloudServiceSchool: {
					id: '',
					schoolName: '',
					schoolUrl: '',
					addressProvince: '',
					addressCity: '',
					addressCounty: '',
					iosDownload:'',
					androidDownload:''
				}
			}
		},
		created: function(){
			this.eid = this.$route.params.eid;
			this.title = this.$route.params.title;
			this.$nextTick(function(){
				this.getAllProvinceList();
			})
		},
		mounted: function(){
			this.$nextTick(function(){
				this.queryProvinceCity('0','0','9999999999999');
				this.getEditSchool();
			})
		},
		methods: {
			getEditSchool(){
				var temp = this;
				if(null == temp.eid || '' == temp.eid) {
					return false;
				}
				this.$http.post('/zklccloud/findSchoolInfoBySchoolid', {
					"schoolId": temp.eid
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == '0') {
						temp.tCloudServiceSchool = m.body.content.tCloudServiceSchool;
						temp.queryProvinceCityF('0','0',m.body.content.tCloudServiceSchool.addressProvince);
						temp.queryProvinceCityF('0','1',m.body.content.tCloudServiceSchool.addressCity);
					} else {
						MessageBox('查询失败！', '提示', 'error', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					}
				})
			},
			getAllProvinceList() {
				var temp = this;
				this.$http.post('/zklccloud/findAllProvinceList', {
					emulateJSON: true
				}).then(function(m) {
					temp.provinceOptions = m.body.content.provinceList;
				})
			},
			queryProvinceCityF(code, level, vc) {
				var temp = this;
				if("" != vc) {
					$.ajax({
						url: "/zklccloud/queryProvinceCityF",
						type: "post",
						data: {
							"code": vc
						},
						async: false,
						dataType: "json",
						success: function(data) {
							//组装数据
							if(level == "0") {
								temp.cityOptions = data.content.provinceCityList;
							} else if(level == "1") {
								temp.streetOptions = data.content.provinceCityList;
							}
						}
					});
				} else {
					if(level == "0") {
						temp.cityOptions = "";
					} else if(level == "1") {
						temp.streetOptions = "";
					}
				}
			},
			queryProvinceCity(code, level, e) {
				var temp = this;
				//初始进入 e 默认赋值  解决火狐下报错问题
				if(e == '9999999999999'){
					$.ajax({
						url: "/zklccloud/queryProvinceCity",
						type: "post",
						data: {
							"code": null
						},
						async: false,
						dataType: "json",
						success: function(data) {
							//组装数据
							if(level == "0") {
								temp.cityOptions = data.content.provinceCityList;
							} else if(level == "1") {
								temp.streetOptions = data.content.provinceCityList;
							}
						}
					});
				}else{
					e = window.event || e;
					var obj = e.srcElement ? e.srcElement : e.target;
						if("" != obj.value) {
						   $.ajax({
							url: "/zklccloud/queryProvinceCity",
							type: "post",
							data: {
								"code": obj.value
							},
							async: false,
							dataType: "json",
							success: function(data) {
								//组装数据
								if(level == "0") {
									temp.cityOptions = data.content.provinceCityList;
								} else if(level == "1") {
									temp.streetOptions = data.content.provinceCityList;
								}
							}
						});
					} else {
						if(level == "0") {
							temp.cityOptions = "";
						} else if(level == "1") {
							temp.streetOptions = "";
						}
					}
				}
				
			},
			doSubmit(e){
				e = e || window.event;
				var temp = this;
				var name = $("#school_name"),
				    android = $("#android_url"),
				    ios = $("#ios_url"),
				    ip = $("#school_ip");
				      
				if($(e.target).html() == '取消') {
					this.$router.go(-1);
				}else{
					if('' == name.val()){
						MessageBox('学校名称不能为空', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							name.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(!/(http[s]?|ftp):\/\/[^\/\.]+?\..+\w$/i.test(ip.val()) || '' == ip.val()){
						MessageBox('请输入正确学校URL，并以http(s)开头', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							ip.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if('' == android.val()){
						MessageBox('android应用下载地址不能为空', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							android.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					}else if('' == ios.val()){
						MessageBox('IOS应用下载地址不能为空', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							ios.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					}
					var formData = JSON.stringify(temp.tCloudServiceSchool);
					this.$http.post('/zklccloud/createTCloudServiceSchool', formData, {emulateJSON: true}).then(function(m) {
						if(m.body.resultCode == '0'){
							MessageBox('操作成功', '提示', 'success', {
								confirmButtonText: '确定',
							}).then(()=>{
								this.$router.push({
									name: 'service_school'
							})
						})
						} else if(m.body.resultCode == '-1'){
							MessageBox('操作失败，请联系管理员', '提示', 'warning', {
								confirmButtonText: '确定',
							})
						}
	
						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					})
				}
				
			}
		}
	}
</script>

<style scoped>
	.basic_container .container-fluid{
		padding-top: 15px;
	}
	.basic_container .form_label {
		min-width: 77px;
	}
	.btn_box {
		padding-top: 15px;
	}
	.form_box {
		width: 600px;
		margin: 0 auto 10px;
	}
</style>


// WEBPACK FOOTER //
// schoolinfo_edit.vue?15702b54